// Newest activity first
export const conversationSelectOptions = () => ({ sort: { lastMessageAt: -1 as const } })
